import { render } from "./CourseDetailsArea.vue?vue&type=template&id=028a3b7a"
import script from "./CourseDetailsArea.vue?vue&type=script&lang=js"
export * from "./CourseDetailsArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__